<template>
    <div>
        <v-dialog
            v-model="display"
            scrollable
            persistent
            :width="drivers.length ? '750' : '500'">
            <v-card>
                <v-card-title>
                    {{ $t('search_driver') }}
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="search"
                        ref="searchField" 
                        @keypress.enter="searchItem"
                        :error="error.searchField.state"
                        :error-messages="error.searchField.message"
                        :loading="loading.driverSearch"
                        :label="$t('search')">
                    </v-text-field>
                     <v-data-table
                        v-if="drivers.length"
                        dense
                        hide-default-footer
                        :items="drivers"
                        disable-pagination
                        :height="drivers.length ? '300' : '100'"
                        v-model="selected.driver"
                        :headers="headers.driver"
                        show-select
                        single-select>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="submit({target: 'submit'})" text>
                        {{ $t('btn_select') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('BTN_CLOSE') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="authorizations.drivers.create" @click="openDriverDialog({editMode: false})" text>
                        <v-icon>mdi-database-plus</v-icon>
                        {{ $t('DRIVER_NEW_TITLE') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <DriverDialog
            @record="createAndSubmitNewDriver"
            ref="driverDialog"/>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import DriverDialog from '@/components/DriverDialog'
export default {
    name: "DriverSearchDialog",
    components: {
        DriverDialog
    },
    data() {
        return {
            display: false,
            search: null,
            loading: {
                data: false,
                driverSearch: false,
            },
            selected: {
               driver: [] 
            },
            headers: {
                driver: [
                    { text: this.$t('DRIVER_NAME'), value: 'name' },
                    { text: this.$t('EXT_WORKSHOP_PHONE'), value: 'phone' }
                ]
            },
            error: {
                searchField: {
                    state: false,
                    message: null
                }
            }, 
        }
    },
    computed: {
        ...mapState("driver", ["drivers"]),
        ...mapState("authentication", ["authorizations"]),
    },
    methods: {
        ...mapActions("driver", ["fetchDrivers", "restDrivers"]),
        open(params) {
            this.search = params;
            this.restDrivers();
            this.display = true;
            this.searchItem();
        },
         setError(message){
            this.error.searchField.state = true;
            this.error.searchField.message = message;
        },
        clearError(){
            this.error.searchField.state = false;
            this.error.searchField.message = null;
        },
        openDriverDialog(params) {
            this.$refs.driverDialog.open(params);
        },
        createAndSubmitNewDriver(params){
           this.submit({target: 'CreateAndSubmit', data: params})
        },
        async searchItem() {
           
            if(this.search) {
                this.restDrivers();
                this.clearError();
                this.loading.driverSearch = true;
                try {
                    await this.fetchDrivers({ search: this.search });
                    this.loading.driverSearch = false;
                    if(!this.drivers.length) this.setError(this.$t('no_result'));
                    if(this.drivers.length == 1) this.submit({ target: 'submit'});
                } catch(error) {
                    this.loading.driverSearch = false;
                    let message = error.response ? error.response.data.message : error; 
                    this.setError(message);
                }

            } else {
                this.setError(this.$t('rules_required'))
            }
       },

       submit(params) {
           if(params.target == 'CreateAndSubmit') {
                  this.$emit('submit', params.data);
           } else if(params.target == 'submit') {
               if(this.drivers.length == 1) this.$emit('submit', this.drivers[0]);
               else this.$emit('submit', this.selected.driver[0]);
           }
            this.close();
       },
        close() {
            this.display = false;
            this.search = null;
            this.selected.driver = [];
            this.restDrivers();
        }
    }
}
</script>